import type { AppLocale } from "../i18n";

const labels = {
  en: ["Financial records", "Active fulfillment", "Open dispute", "Payment resolution", "Legal hold", "Backup rotation"],
  es: ["Registros financieros", "Entrega en curso", "Disputa abierta", "Resolución de pagos", "Conservación legal", "Rotación de copias de seguridad"],
  fr: ["Documents financiers", "Exécution en cours", "Litige ouvert", "Résolution du paiement", "Conservation légale", "Rotation des sauvegardes"],
  de: ["Finanzunterlagen", "Laufende Auftragserfüllung", "Offener Streitfall", "Zahlungsabwicklung", "Gesetzliche Aufbewahrung", "Rotation der Sicherungskopien"],
  pt: ["Registos financeiros", "Expedição em curso", "Litígio aberto", "Resolução de pagamentos", "Retenção legal", "Rotação de cópias de segurança"],
  "zh-Hans": ["财务记录", "正在履约", "未结争议", "付款处理", "依法保留", "备份轮换"],
  ja: ["財務記録", "進行中の履行", "未解決の紛争", "決済処理", "法的保全", "バックアップの順次削除"],
  ko: ["재무 기록", "진행 중인 이행", "미해결 분쟁", "결제 해결", "법적 보존", "백업 순환 삭제"],
  ar: ["السجلات المالية", "تنفيذ الطلب الجاري", "نزاع مفتوح", "تسوية الدفع", "حفظ قانوني", "تدوير النسخ الاحتياطية"],
  hi: ["वित्तीय रिकॉर्ड", "चल रही पूर्ति", "खुला विवाद", "भुगतान निपटान", "कानूनी संरक्षण", "बैकअप का क्रमिक हटाव"],
  ms: ["Rekod kewangan", "Pemenuhan yang sedang berjalan", "Pertikaian terbuka", "Penyelesaian pembayaran", "Penahanan undang-undang", "Giliran sandaran"]
} satisfies Record<AppLocale, readonly string[]>;

const keys = ["financial_records", "active_fulfillment", "open_dispute", "payment_resolution", "legal_hold", "backup_rotation"] as const;

// A category this build has no copy for (a newer API) gets a localized generic
// label, never the raw English-looking id.
const otherLabel = {
  en: "Other retained records",
  es: "Otros registros conservados",
  fr: "Autres documents conservés",
  de: "Sonstige aufbewahrte Unterlagen",
  pt: "Outros registos conservados",
  "zh-Hans": "其他保留记录",
  ja: "その他の保管記録",
  ko: "기타 보관 기록",
  ar: "سجلات أخرى محفوظة",
  hi: "अन्य रखे गए रिकॉर्ड",
  ms: "Rekod lain yang disimpan"
} satisfies Record<AppLocale, string>;

export const retainedCategoryCopy = { labels, otherLabel } as const;

export function retainedCategoryLabel(locale: AppLocale, key: string): string {
  const index = keys.findIndex(candidate => candidate === key);
  return index < 0 ? otherLabel[locale] : labels[locale][index]!;
}
